import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store';
import ElementUI from 'element-ui';
import './style/index.scss'
const theme = localStorage.getItem('theme') || 'purple';
document.body.className = `theme-${theme}`;
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(Vant);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
